<template>
  <div>
    <v-layout row justify-center align-center>
      <table>
        <thead>
          <tr>
            <th class="payment-cells">{{ $t('extracurriculares.pay_reserve.student') }}</th>
            <th class="payment-cells">Tipo de curso</th>
            <th class="payment-cells">Curso</th>
            <th class="payment-cells"></th>
            <th class="payment-cells"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(register, index) in registered_courses" :key="index">
            <td align="center" v-if="register.student">{{register.student.full_name}}</td>
            <td align="center" v-else>{{register.student_ext.full_name}}</td>
            <td align="center">{{register.course.course_type.name}}</td>
            <td align="center">{{register.course.name}}</td>
            <td>
              <v-btn block outline color="info" v-if="register.user_dependant_id" @click="registerSchedules(register.course_id, register.user_dependant_id, true)">Horarios</v-btn>
              <v-btn block outline color="info" v-else @click="registerSchedules(register.course_id, register.student_id)">Horarios</v-btn>
            </td>
            <td>
              <v-btn block color="info" v-if="register.student" @click="openClothesDetail(register.student.id)">{{ $t('extracurriculares.pay_reserve.clothes') }}</v-btn>
              <v-btn block color="info" v-else @click="openClothesDetail(register.student_ext.id)">{{ $t('extracurriculares.pay_reserve.clothes') }}</v-btn>
            </td>
          </tr>
        </tbody>
      </table>
    </v-layout>
      <v-dialog
        v-if="schedules"
        v-model="register_detail_dialog"
        width="750"
        persistent
      >
      <v-card>
        <v-layout pt-3 row justify-center align-center>
            <v-flex class="ma-2" xs12>
              <table width="95%">
                <thead>
                  <tr>
                    <th align="center">{{ $t('extracurriculares.courses.teachers_modal.schedule') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(course, index) in schedules" :key="index">
                    <td align="center">{{ course.schedule.name }}</td>
                  </tr>
                </tbody>
              </table>
            </v-flex>
        </v-layout>
        <v-layout row justify-center align-center>
          <v-btn
            color="primary"
            @click="register_detail_dialog = false"
          >
            {{ $t('close') }}
          </v-btn>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="course_clothes_dialog"
        width="750"
        persistent
      >
      <course-clothes
        :course_clothes="courses_clothes"
      >
      </course-clothes>
      <v-card class="pt-3">
        <v-layout row justify-center align-center>
          <v-btn
            color="primary"
            @click="course_clothes_dialog = false"
          >
            {{ $t('close') }}
          </v-btn>
        </v-layout>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import axios from 'axios'
  import courseClothes from './course_clothes'
  export default {
    name: 'enrolled-courses',
    components: {
      'course-clothes': courseClothes,
    },
    created () {
      this.getEnrollments()
    },
    data() {
      return {
        terms_check: false,
        terms_error_dialog: false,
        terms_dialog: false,
        appUrl: window.config.appUrl,
        payment_dialog: false,
        loading_button: 0,
        payment_detail_dialog: false,
        payment_to_show: {},
        payment_detail: '',
        register_detail_dialog: false,
        register_detail: [],
        register_detail_type: '',
        register_detail_id: '',
        idPago: '',
        payment_loading: 0,
        register_detail_student_id: '',
        register_detail_external: false,
        validations: 0,
        transport_modal: false,
        transport_items: [
          { value: 'asia', text: 'Asia' },
          { value: 'senderos', text: 'Senderos' },
          { value: 'buseticas', text: 'Buseticas' },
        ],
        transport: '',
        transport_type: '',
        transport_id: '',
        transport_total: '',
        transport_course_type_id: '',
        transport_student_id: '',
        courses_clothes: [],
        schedules: null,
        course_clothes_dialog: false,
        course_clothes_student: '',
        external_transport: false,
        registered: [],
        registered_courses: []
      }
    },
    watch: {
      course_clothes_dialog(newValue, oldValue) {
        if (oldValue && !newValue) {

          this.$store.dispatch('fetchRegisteredCourses')
          this.course_clothes_student = ''
        }
      }
    },
    computed: {
      ...mapGetters({
        loading: 'loading',
        locale: 'locale'
      })
    },
    methods: {
      async getEnrollments() {
        await axios.get('/api/extracurriculares/family_enrollments')
          .then(resp => {
            if (resp.status === 200) {
              this.registered = resp.data
              this.registered.forEach(course => {
                if (course.user_dependant_id) {
                  var existingValue = this.registered_courses.find(reg => reg.course_id === course.course_id && reg.user_dependant_id === course.user_dependant_id)
                } else {
                  var existingValue = this.registered_courses.find(reg => reg.course_id === course.course_id && reg.student_id === course.student_id)
                }
                if (!existingValue) {
                  this.registered_courses.push(course);
                }
              });
            }
          })
          .catch(error => console.log(error))

      },
      registerSchedules(id, student_id, external = false) {
        let courses = []
        if (external) {
          courses = this.registered
            .filter(reg => reg.user_dependant_id === student_id && reg.course_id === id)
        } else {
          courses = this.registered
            .filter(reg => reg.student_id === student_id && reg.course_id === id)
        }
        this.schedules = courses
        this.register_detail_dialog = true
      },
      formatNumber(number) {
        if(!number || typeof number === 'undefined') {
            return 0;
        } else {
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        }
      },
      openClothesDetail(student_id, external = false) {
        let courses = []
        if (external) {
          courses = this.registered
            .filter(register => register.user_dependant_id === student_id)
        } else {
          courses = this.registered
            .filter(register => register.student_id === student_id)
        }
          this.course_clothes_student = student_id
          this.courses_clothes = courses
          this.course_clothes_dialog = true
      }
    },
  }
</script>

<style>
  table, td, th {
    padding: 10px 5px;
  }

  table {
    border: 1px solid lightgray;
    width: 100%;
  }

  tr:nth-child(even) {
    background: rgb(233, 233, 233);
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/extracurriculares/enrollment/enrolled_courses.vue